export const DOUGS_PARTNER_CODE = 'dougs-dougs-comptepro-526';
export const DOUGS_PARTNER_NAME_PROD = 'Dougs - Compte Pro';
export const DOUGS_PARTNER_NAME_STAGING = 'Dougs Pro Account Staging';
export const DOUGS_PARTNER_DISPLAY_NAME = 'Dougs';
// Values the `partner_name` API field can hold for the Dougs embed partner,
// depending on environment/data.
export const DOUGS_PARTNER_IDENTIFIERS = [
  DOUGS_PARTNER_CODE.toLowerCase(),
  DOUGS_PARTNER_NAME_PROD.toLowerCase(),
  DOUGS_PARTNER_NAME_STAGING.toLowerCase(),
];
